var render, staticRenderFns
import script from "./EasyButton.vue?vue&type=script&lang=js&"
export * from "./EasyButton.vue?vue&type=script&lang=js&"
import style0 from "./EasyButton.vue?vue&type=style&index=0&id=39f133f1&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports